module.exports = __webpack_public_path__ + "static/skullAR-3a8899c3b63bd62fa071c846b3bc9fbf.mp4";